import { useTranslation } from 'react-i18next'
import React from 'react'

import { useRowActionsColumn } from '../../../../../components/tables/Table'
import { useConfig } from '../_load/ConfigsLoader'
import { RefetchingIndicator } from '../../../../../packages/kiti/components/helpers/StatePresenter'
import { useSlaConfigsActions } from '../../../_actions/configsActions'
import DataTable from '../../../../../packages/kiti/components/table/DataTable'
import { formatDate } from '@btime/helpers'
import { Bold, Span } from '../../../../../packages/kiti/components/presentation/Text'
import { COLORS } from '@btime/constants'
import { convertSecondsToSla } from '../../edit/_request/cleanRequest'
import IconBlock from '../../../../../components/presentation/IconBlock'
import Center from '../../../../../components/helpers/Center'
import { InfoIconTooltip } from '../../../../../components/helpers/InfoIconTooltip'

const ConfigsTable = () => {
  const { t } = useTranslation(['listSla', 'common'])
  const data = useConfig()

  const formatSlaUnit = value => {
    if (!value) return ''

    const options = [
      { name: t('listSla:slaUnits.day'), id: 'day' },
      { name: t('listSla:slaUnits.hour'), id: 'hour' },
      { name: t('listSla:slaUnits.minute'), id: 'minute' }
    ]

    return options.find(option => option.id === value)?.name
  }

  const formatSlaType = value => {
    if (!value) return ''

    const options = [
      { name: t('listSla:slaTypes.creationDate'), id: 'creationDate' },
      { name: t('listSla:slaTypes.schedulingDate'), id: 'schedulingDate' }
    ]

    return options.find(option => option.id === value)?.name
  }

  const columns = [
    {
      label: t('listSla:name'),
      headerSideContent: (
        <>
          <RefetchingIndicator />
        </>
      ),
      flex: 3,
      render: item => {
        const checklistName = item.value?.checklists?.[0]?.name || ''
        const placeName = item.value?.places?.[0]?.name || ''

        return (
          <>
            <Bold color={COLORS.dark2} breakWord>
              {checklistName}
            </Bold>
            {placeName && (
              <Span strong color={COLORS.dark2} breakWord>
                {` - ${placeName}`}
              </Span>
            )}
          </>
        )
      }
    },
    {
      label: t('listSla:slaType'),
      flex: 2,
      render: item => (
        <>
          <Span color={COLORS.dark2} breakWord>
            {formatSlaType(item.value?.sla_type)}
          </Span>
        </>
      )
    },
    {
      label: t('listSla:duration'),
      flex: 2,
      render: item => (
        <>
          <Span color={COLORS.dark2} breakWord>
            {convertSecondsToSla(item.value?.duration_in_seconds, item.value?.sla_unit)}
          </Span>
        </>
      )
    },
    {
      label: t('listSla:slaUnit'),
      flex: 2,
      render: item => (
        <>
          <Span color={COLORS.dark2} breakWord>
            {formatSlaUnit(item.value?.sla_unit)}
          </Span>
        </>
      )
    },
    {
      label: t('listSla:checklists'),
      flex: 2,
      render: item => (
        <div style={{ display: 'flex', alignItems: 'center', color: COLORS.dark2 }}>
          <span style={{ marginRight: '5px' }}>{item.value?.checklists?.length}</span>
          <InfoIconTooltip text={item.value?.checklists?.map(checklist => checklist.name).join(', ')} />
        </div>
      )
    },
    {
      label: t('listSla:places'),
      flex: 2,
      render: item => (
        <div style={{ display: 'flex', alignItems: 'center', color: COLORS.dark2 }}>
          <span style={{ marginRight: '5px' }}>{item.value?.places?.length}</span>
          <InfoIconTooltip text={item.value?.places?.map(checklist => checklist.name).join(', ')} />
        </div>
      )
    },
    {
      label: t('listSla:createdAt'),
      dataIndex: 'insertedAt',
      sortIndex: 'INSERTED_AT',
      flex: 2,
      format: formatDate('DD/MM/YYYY HH:mm')
    },
    {
      label: t('common:actions'),
      width: 3,
      render: useRowActionsColumn(useSlaConfigsActions)
    }
  ]

  if (!data?.length) {
    return (
      <Center height="100%">
        <IconBlock icon="BsInbox" title={t('listSla:emptyMessage')} />
      </Center>
    )
  }

  return <DataTable data={data} columns={columns} />
}

export default ConfigsTable
